import React, { useState } from 'react'
import copyToClipboard from 'helpers/copyToClipboard'
import LinkIcon from '@mui/icons-material/Link'
import TealToolTip from 'components/TealToolTip'
import IconButton from '@mui/material/IconButton'
import CommentIcon from '@mui/icons-material/Chat'

const ParameterComment = ({ comment }) => {
  const [open, setOpen] = useState(false)

  const handleOnClick = () => {
    copyToClipboard(comment, 'Comment copied to clipboard')
    setOpen(!open)
  }

  if (!comment) return null

  return (
    <TealToolTip
      title={comment}
      placement='top'
      open={open}
    >
      <IconButton
        size='small'
        classes={{ sizeSmall: 'pa3' }}
        onClick={handleOnClick}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        data-testid='parameter-comment-icon'
      >
        {open
          ? <LinkIcon className='w7 vm dark-sea-green-2 mt1' />
          : <CommentIcon className='w7 vm dark-sea-green-2 mt1' />}
      </IconButton>
    </TealToolTip>
  )
}

export default ParameterComment
